


































































































































































































import Vue from "vue";
import InteractionState from "@/Globals/InteractionState";

export default Vue.extend({
  methods: {
    changeState(stateKey: string) {
      switch (stateKey) {
        case "wps":
          this.$store.commit(
            "changeState",
            InteractionState.WebProjectShowcase
          );
          break;

        case "ar":
          this.$store.commit("changeState", InteractionState.AugmentedReality);
          break;

        case "gde":
          this.$store.commit(
            "changeState",
            InteractionState.GameDevelopmentExperience
          );
          break;

        case "v":
          this.$store.commit("changeState", InteractionState.Ventures);
          break;

        case "bsm":
          this.$store.commit(
            "changeState",
            InteractionState.BlogAndSocialMedia
          );
          break;

        case "c":
          this.$store.commit("changeState", InteractionState.Contact);
          break;

        default:
          break;
      }
    }
  }
});
